<template>
  <Layout >
      <div class="service_container">
        <!-- part1顶部轮播图 -->
        <div class="CRM_swiper_part slider-area slider-style-4 slider-dot rn-slick-dot rn-slick-arrow" :style="{'background-image': 'url(' + CRMSwiperBg + ')', height:'100%',width:'100%', backgroundSize:'cover',backgroundRepeat:'no-repeat',
        backgroundPosition:'center center'}">
          
          <VueSlickCarousel v-bind="crmSwiperSettings" pauseOnFocus pauseOnHover :autoplaySpeed="5000" dotsClass="slick-dots service-dots">

            <!-- 第一页开始 -->
            <div class="CRM_swiper_box">
              <div class="CRM_swiper_top">
                <div class="titleBox">
                  <div class="title">Dynamics CRM</div>
                  <div class="triangle"></div>
                </div>
              </div>
              <div class="CRM_swiper_content row">
                <div class="CRM_swiper_text_box col-lg-6 col-md-12 col-sm-12 col-12">
                  <vyung-scroll ref="scroll" vertical>
                  <div class="mark_title">{{ $t("service.dynamics_crm.tab01.head_title") }}</div>
                  <div class="divide_line"></div>
                  <div class="mark_text">{{ $t("service.dynamics_crm.tab01.title01") }}</div>
                  <div class="detail">{{ $t("service.dynamics_crm.tab01.description01") }}</div>
                  <div class="mark_text">{{ $t("service.dynamics_crm.tab01.title02") }}</div>
                  <div class="detail">{{ $t("service.dynamics_crm.tab01.description02") }}</div>
                  <div class="mark_text">{{ $t("service.dynamics_crm.tab01.title03") }}</div>
                  <div class="detail">{{ $t("service.dynamics_crm.tab01.description03") }}</div>
                </vyung-scroll>
                </div>
                <div class="CRM_swiper_img_box col-lg-6 col-md-12 col-sm-12 col-12">
                  <div class="CRM_swiper_img water-mark" :data-content="$t('product.example')">
                    <img  
                    :src="require(`../../assets/images/serviceAbility/CRM_swiperTab_img1.png`)" alt="">
                  </div>
                </div>
              </div>
            </div>

            <!-- CRM轮播图第二页开始 -->
            <div class="CRM_swiper_box">
              <div class="CRM_swiper_top">
                <div class="titleBox">
                  <div class="title">Dynamics CRM</div>
                  <div class="triangle"></div>
                </div>
              </div>
              <div class="CRM_swiper_content row">
                <div class="CRM_swiper_text_box col-lg-6 col-md-12 col-sm-12 col-12">
                  <vyung-scroll vertical>
                  <div class="mark_title">{{ $t("service.dynamics_crm.tab02.head_title") }}</div>
                  <div class="divide_line"></div>
                  <div class="mark_text">{{ $t("service.dynamics_crm.tab02.title01") }}</div>
                  <div class="detail">{{ $t("service.dynamics_crm.tab02.description01") }}</div>
                  <div class="mark_text">{{ $t("service.dynamics_crm.tab02.title02") }}</div>
                  <div class="detail">{{ $t("service.dynamics_crm.tab02.description02") }}</div>
                  <div class="mark_text">{{ $t("service.dynamics_crm.tab02.title03") }}</div>
                  <div class="detail">{{ $t("service.dynamics_crm.tab02.description03") }}</div>
                  </vyung-scroll>
                </div>
                <div class="CRM_swiper_img_box col-lg-6 col-md-12 col-sm-12 col-12">
                  <div class="CRM_swiper_img water-mark" :data-content="$t('product.example')">
                    <img  
                    :src="require(`../../assets/images/serviceAbility/CRM_swiperTab_img2.png`)" alt="">
                  </div>
                </div>
              </div>
            </div>

            <!-- CRM轮播图第三页开始 -->
            <div class="CRM_swiper_box">
              <div class="CRM_swiper_top">
                <div class="titleBox">
                  <div class="title">Dynamics CRM</div>
                  <div class="triangle"></div>
                </div>
              </div>
              <div class="CRM_swiper_content row">
                <div class="CRM_swiper_text_box col-lg-6 col-md-12 col-sm-12 col-12">
                  <vyung-scroll vertical>
                  <div class="mark_title">{{ $t("service.dynamics_crm.tab03.head_title") }}</div>
                  <div class="divide_line"></div>
                  <div class="mark_text">{{ $t("service.dynamics_crm.tab03.title01") }}</div>
                  <div class="detail">{{ $t("service.dynamics_crm.tab03.description01") }}</div>
                  <div class="mark_text">{{ $t("service.dynamics_crm.tab03.title02") }}</div>
                  <div class="detail">{{ $t("service.dynamics_crm.tab03.description02") }}</div>
                  <div class="mark_text">{{ $t("service.dynamics_crm.tab03.title03") }}</div>
                  <div class="detail">{{ $t("service.dynamics_crm.tab03.description03") }}</div>
                </vyung-scroll>
                </div>
                <div class="CRM_swiper_img_box col-lg-6 col-md-12 col-sm-12 col-12">
                  <div class="CRM_swiper_img water-mark" :data-content="$t('product.example')">
                    <img 
                    :src="require(`../../assets/images/serviceAbility/CRM_swiperTab_img3.png`)" alt="">
                  </div>
                </div>
              </div>
            </div>

            <!-- CRM第四页开始 -->
            <div class="CRM_swiper_box">
              <div class="CRM_swiper_top">
                <div class="titleBox">
                  <div class="title">Dynamics CRM</div>
                  <div class="triangle"></div>
                </div>
              </div>
              <div class="CRM_swiper_content row">
                <div class="CRM_swiper_text_box col-lg-6 col-md-12 col-sm-12 col-12">
                  <vyung-scroll vertical>
                  <div class="mark_title">{{ $t("service.dynamics_crm.tab04.head_title") }}</div>
                  <div class="divide_line"></div>
                  <div class="mark_text">{{ $t("service.dynamics_crm.tab04.title01") }}</div>
                  <div class="detail">{{ $t("service.dynamics_crm.tab04.description01") }}</div>
                  <div class="mark_text">{{ $t("service.dynamics_crm.tab04.title02") }}</div>
                  <div class="detail">{{ $t("service.dynamics_crm.tab04.description02") }}</div>
                  <div class="mark_text">{{ $t("service.dynamics_crm.tab04.title03") }}</div>
                  <div class="detail">{{ $t("service.dynamics_crm.tab04.description03") }}</div>
                  <div class="mark_text">{{ $t("service.dynamics_crm.tab04.title04") }}</div>
                  <div class="detail">{{ $t("service.dynamics_crm.tab04.description04") }}</div>
                  <div class="mark_text">{{ $t("service.dynamics_crm.tab04.title05") }}</div>
                  <div class="detail">{{ $t("service.dynamics_crm.tab04.description05") }}</div>
                </vyung-scroll>
                </div>
                <div class="CRM_swiper_img_box col-lg-6 col-md-12 col-sm-12 col-12">
                  <div class="CRM_swiper_img water-mark" :data-content="$t('product.example')">
                    <img  
                    :src="require(`../../assets/images/serviceAbility/CRM_swiperTab_img4.png`)" alt="">
                  </div>
                </div>
              </div>
            </div>
          </VueSlickCarousel>
        
          
        </div>
        <!-- part2切换页 -->
        <div class="ERP_swiper_part" :style="{ height:'100%',width:'100%'}">
          <div class="swiperBox">

            <div class="swiperLeft " >
              <div class="titleBox">
                <div class="title">Dynamics  ERP</div>
                <div class="triangle"></div>
              </div>
              <div class="tabsList water-mark" :data-content="$t('product.example')"
                :style="{
                  'background-image': 'url(' + ERPswiperList[erpCurrent].leftImg + ')', 
                  height:'400px',width:'100%', 
                  backgroundSize:'100% 100%',
                  backgroundRepeat:'no-repeat',
                  backgroundPosition:'center center'}">
                <div 
                :class="`${erpCurrent == index? 'leftItem blue':'leftItem'}`" 
                v-for="(item,index) in ERPswiperList" :key="item.id" @click="changeSwiper(index)"
                >{{item.name}}</div>
              </div>
              
            </div>

            <div class="swiperRight " v-if="erpCurrent == '0'" >
              <vyung-scroll vertical>
              <div class="rightItem marginBottom">
                <div class="itemIcon" 
                :style="{'background-image': 'url(' + swiperTextIcon + ')', height:'20px',width:'20px', backgroundSize:'cover',
                backgroundRepeat:'no-repeat',backgroundPosition:'center center'}">
                </div>
                <div class="itemText">
                  <div class="textTitle">{{ ERPswiperList[erpCurrent].title01 }}</div>
                  <div class="textDetail">{{ ERPswiperList[erpCurrent].description01 }}</div>
                </div>
              </div>
              <div class="rightItem marginBottom">
                <div class="itemIcon" 
                :style="{'background-image': 'url(' + swiperTextIcon + ')', height:'20px',width:'20px', backgroundSize:'cover',
                backgroundRepeat:'no-repeat',backgroundPosition:'center center'}">
                </div>
                <div class="itemText">
                  <div class="textTitle">{{ ERPswiperList[erpCurrent].title02 }}</div>
                  <div class="textDetail">{{ ERPswiperList[erpCurrent].description02 }}</div>
                </div>
              </div>
              <div class="rightItem marginBottom">
                <div class="itemIcon" 
                :style="{'background-image': 'url(' + swiperTextIcon + ')', height:'20px',width:'20px', backgroundSize:'cover',
                backgroundRepeat:'no-repeat',backgroundPosition:'center center'}">
                </div>
                <div class="itemText">
                  <div class="textTitle">{{ ERPswiperList[erpCurrent].title03 }}</div>
                  <div class="textDetail">{{ ERPswiperList[erpCurrent].description03 }}</div>
                </div>
              </div>
              <div class="rightItem">
                <div class="itemIcon" 
                :style="{'background-image': 'url(' + swiperTextIcon + ')', height:'20px',width:'20px', backgroundSize:'cover',
                backgroundRepeat:'no-repeat',backgroundPosition:'center center'}">
                </div>
                <div class="itemText">
                  <div class="textTitle">{{ ERPswiperList[erpCurrent].title04 }}</div>
                  <div class="textDetail">{{ ERPswiperList[erpCurrent].description04 }}</div>
                  <div class="textTitle">{{ ERPswiperList[erpCurrent].description05 }}</div>
                  <!-- <img width="100%" :src="require('../../assets/images/serviceAbility/erp_tab01_img_r.png')" alt=""> -->
                </div>
              </div>
            </vyung-scroll>
            </div>
            <div class="swiperRight " v-else-if="erpCurrent == '1'" >
              <vyung-scroll vertical>
              <div class="rightItem marginBottom">
                <div class="itemIcon" 
                :style="{'background-image': 'url(' + swiperTextIcon + ')', height:'20px',width:'20px', backgroundSize:'cover',
                backgroundRepeat:'no-repeat',backgroundPosition:'center center'}">
                </div>
                <div class="itemText">
                  <div class="textTitle">{{ ERPswiperList[erpCurrent].title01 }}</div>
                  <div class="textDetail">{{ ERPswiperList[erpCurrent].description01 }}</div>
                </div>
              </div>
              <div class="rightItem marginBottom">
                <div class="itemIcon" 
                :style="{'background-image': 'url(' + swiperTextIcon + ')', height:'20px',width:'20px', backgroundSize:'cover',
                backgroundRepeat:'no-repeat',backgroundPosition:'center center'}">
                </div>
                <div class="itemText">
                  <div class="textTitle">{{ ERPswiperList[erpCurrent].title02 }}</div>
                  <div class="textDetail">{{ ERPswiperList[erpCurrent].description02 }}</div>
                </div>
              </div>
              <div class="rightItem marginBottom">
                <div class="itemIcon" 
                :style="{'background-image': 'url(' + swiperTextIcon + ')', height:'20px',width:'20px', backgroundSize:'cover',
                backgroundRepeat:'no-repeat',backgroundPosition:'center center'}">
                </div>
                <div class="itemText">
                  <div class="textTitle">{{ ERPswiperList[erpCurrent].title03 }}</div>
                  <div class="textDetail">{{ ERPswiperList[erpCurrent].description03 }}</div>
                </div>
              </div>
              <div class="rightItem marginBottom">
                <div class="itemIcon" 
                :style="{'background-image': 'url(' + swiperTextIcon + ')', height:'20px',width:'20px', backgroundSize:'cover',
                backgroundRepeat:'no-repeat',backgroundPosition:'center center'}">
                </div>
                <div class="itemText">
                  <div class="textTitle">{{ ERPswiperList[erpCurrent].title04 }}</div>
                  <div class="textDetail">{{ ERPswiperList[erpCurrent].description04 }}</div>
                </div>
              </div>
              <div class="rightItem">
                <div class="itemIcon" 
                :style="{'background-image': 'url(' + swiperTextIcon + ')', height:'20px',width:'20px', backgroundSize:'cover',
                backgroundRepeat:'no-repeat',backgroundPosition:'center center'}">
                </div>
                <div class="itemText">
                  <div class="textTitle">{{ ERPswiperList[erpCurrent].title05 }}</div>
                  <div class="textDetail">{{ ERPswiperList[erpCurrent].description05 }}</div>
                  <div class="textTitle">{{ ERPswiperList[erpCurrent].description06 }}</div>
                  <img width="100%" :src="require('../../assets/images/serviceAbility/erp_tab02_img_r.png')" alt="">
                </div>
              </div>
            </vyung-scroll>
            </div>
            <div class="swiperRight " v-else-if="erpCurrent == '2'" >
              <vyung-scroll vertical>
              <div class="rightItem">
                <div class="itemIcon" 
                :style="{'background-image': 'url(' + swiperTextIcon + ')', height:'20px',width:'20px', backgroundSize:'cover',
                backgroundRepeat:'no-repeat',backgroundPosition:'center center'}">
                </div>
                <div class="itemText">
                  <div class="textTitle">{{ ERPswiperList[erpCurrent].title01 }}</div>
                  <div class="textDetail">{{ ERPswiperList[erpCurrent].description01 }}</div>
                  <div class="textDetail">{{ ERPswiperList[erpCurrent].description02 }}</div>
                  <div class="textDetail">{{ ERPswiperList[erpCurrent].description03 }}</div>
                  <div class="textDetail">{{ ERPswiperList[erpCurrent].description04 }}</div>
                  <div class="textDetail">{{ ERPswiperList[erpCurrent].description05 }}</div>
                  <div class="textDetail">{{ ERPswiperList[erpCurrent].description06 }}</div>
                  <div class="textDetail">{{ ERPswiperList[erpCurrent].description07 }}</div>
                  <!-- <img width="100%" :src="require('../../assets/images/serviceAbility/erp_tab02_img_r.png')" alt=""> -->
                </div>
              </div>
            </vyung-scroll>
            </div>
          </div>
        </div>
        

        <!-- part3 SFA APP -->
        <div class="SFA_App_box">
          <div class="titleBox">
            <div class="title">Power  Platform</div>
            <div class="triangle"></div>
          </div>
          <div class="SFA_app_content pad_top">
            <div class="sfa_img_list">
              <div class="sfa_img sfa_img_padding water-mark" :data-content="$t('product.example')"  v-for="(item,index) in SFAPhoneImgs" :key="index">
                  <img  
                  :src="require(`../../assets/images/serviceAbility/${item.src}.png`)" alt="">
              </div>
            </div>
            
            <div class="description_area">
              <div class="markTitle textRight" >{{ $t("service.sfa_app.title01") }}</div>
              <div class="divide_line textRight positionRight" ></div>
              <div class="textTitle textRight" >{{ $t("service.sfa_app.title02") }}</div>
              <div class="description textRight" style=" padding-right: -30px;">{{ $t("service.sfa_app.description") }}</div>
              <div class="icons_box">
                <div class="icons_content">
                  <div class="iconItem" v-for="(item,index) in SFAicons" :key="index">
                    <img  
                    :src="require(`../../assets/images/serviceAbility/${item.src}.png`)" alt="">
                  </div>
                </div>
              </div>
            </div>
            
          </div>
        </div>

        <!-- part4 巡店APP -->
        <div class="SFA_App_box" >
          <div class="SFA_app_content" style="padding-top: 0;">
            <div class="description_area mar_l_0" style="width: 360px;">
              <div class="markTitle" >{{ $t("service.store_tour_app.title01") }}</div>
              <div class="divide_line" ></div>
              <div class="textTitle" >{{$t("service.store_tour_app.title02")}}</div>
              <div class="description" >{{ $t("service.store_tour_app.description") }}</div>
            </div>
            <div class="app_icons_box" >
                <div class="icons_content" >
                  <div class="iconItem" v-for="(item,index) in APPicons" :key="index">
                    <img  width="48px" height="48px"
                    :src="require(`../../assets/images/serviceAbility/${item.src}.png`)" alt="">
                  </div>
                </div>
            </div>
            <div class="app_imgList_box">
              <div  class="water-mark" :data-content="$t('product.example')">
                <img 
                :src="require(`../../assets/images/serviceAbility/${APPPhoneImgs[0].src}.png`)" alt="">
              </div>
              <div class="water-mark" :data-content="$t('product.example')" style="margin-left: 40px;" >
                <img 
                :src="require(`../../assets/images/serviceAbility/${APPPhoneImgs[1].src}.png`)" alt="">
              </div>
            </div>
            
          </div>
        </div>

      </div>
  </Layout>
</template>


<script>
    import Layout from '../../components/common/Layout'
    import VueSlickCarousel from 'vue-slick-carousel'
    import VyungScroll from '@/components/elements/scroll/scroll'
    // import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
    export default {
        name: 'ServiceAbility',
        components: { Layout,VueSlickCarousel,VyungScroll},
        data() {
            return {
              coolLightItems:[
                require('../../assets/images/serviceAbility/time_line_img2.png'),
              ],
              coolLightIndex:null,
              timeLineCircle:require('../../assets/images/serviceAbility/time_line_circle.png'),
              erpCurrent:0,
              crmSwiperSettings: {
                    infinite: true,
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    dots: true,
                    arrows: false,
                    adaptiveHeight:true,
                    autoplay:true,
                    autoplaySpeed:10000,
                    pauseOnHover:false,
                    responsive: [
                        {
                            breakpoint: 800,
                            settings: {
                                slidesToShow: 1,
                            }
                        },
                        {
                            breakpoint: 993,
                            settings: {
                                slidesToShow: 1,
                            }
                        },
                        {
                            breakpoint: 580,
                            settings: {
                                slidesToShow: 1,
                            }
                        },
                        {
                            breakpoint: 481,
                            settings: {
                                slidesToShow: 1,
                            }
                        }
                    ]
                },
              CRMSwiperBg:require('../../assets/images/serviceAbility/CRM_swiperTab_bg.png'),
              swiperTextIcon:require('../../assets/images/serviceAbility/swiperTextIcon.png'),
              swiperSrc:require('../../assets/images/serviceAbility/ERP_swiperTab_bg1.png'),
              SFAicons:[
                {src:'SFA_icon1_date'},
                {src:'SFA_icon2_customer'},
                {src:'SFA_icon3_opportunity'},
                {src:'SFA_icon4_order'},
                {src:'SFA_icon5_product'},
                {src:'SFA_icon6_statistics'},
                {src:'SFA_icon7_resource'},
                {src:'SFA_icon8_followUp'},
                {src:'SFA_icon9_email'},
                {src:'SFA_icon10_assistant'},
              ],
              SFAPhoneImgs:[
                {src:'img_phone1_SFA'},
                {src:'img_phone2_SFA'},
                {src:'img_phone3_SFA'},
              ],
              APPicons:[
                {src:'App_icon14_record'},
                {src:'App_icon13_stop'},
                {src:'App_icon12_calendar'},
                {src:'App_icon11_position'},
                {src:'App_icon17_visit'},
                {src:'App_icon16_user'},
                {src:'App_icon15_task'},
              ],
              APPPhoneImgs:[
                {src:'img_phone4_APP'},
                {src:'img_phone5_APP'},
              ],
              CRMswiperList:[
                {
                  id:'one',

                },

              ],
              ERPswiperList:[
                {
                  id:'111',
                  name:this.$t('service.dynamics_erp.tab01.head_title'),
                  number:'1',
                  leftImg:require('../../assets/images/serviceAbility/erp_tab01_img_r.png'),
                  rightImg:require('../../assets/images/serviceAbility/erp_tab01_img_r.png'),
                  title01:this.$t('service.dynamics_erp.tab01.title01'),
                  description01:this.$t('service.dynamics_erp.tab01.description01'),
                  title02:this.$t('service.dynamics_erp.tab01.title02'),
                  description02:this.$t('service.dynamics_erp.tab01.description02'),
                  title03:this.$t('service.dynamics_erp.tab01.title03'),
                  description03:this.$t('service.dynamics_erp.tab01.description03'),
                  title04:this.$t('service.dynamics_erp.tab01.title04'),
                  description04:this.$t('service.dynamics_erp.tab01.description04'),
                  description05:this.$t('service.dynamics_erp.tab01.description05')
                },
                {
                  id:'222',
                  name:this.$t('service.dynamics_erp.tab02.head_title'),
                  number:'1',
                  leftImg:require('../../assets/images/serviceAbility/erp_tab01_img_l.png'),
                  rightImg:require('../../assets/images/serviceAbility/erp_tab02_img_r.png'),
                  title01:this.$t('service.dynamics_erp.tab02.title01'),
                  description01:this.$t('service.dynamics_erp.tab02.description01'),
                  title02:this.$t('service.dynamics_erp.tab02.title02'),
                  description02:this.$t('service.dynamics_erp.tab02.description02'),
                  title03:this.$t('service.dynamics_erp.tab02.title03'),
                  description03:this.$t('service.dynamics_erp.tab02.description03'),
                  title04:this.$t('service.dynamics_erp.tab02.title04'),
                  description04:this.$t('service.dynamics_erp.tab02.description04'),
                  title05:this.$t('service.dynamics_erp.tab02.title05'),
                  description05:this.$t('service.dynamics_erp.tab02.description05'),
                  description06:this.$t('service.dynamics_erp.tab02.description06')
                },{
                  id:'333',
                  name:this.$t('service.dynamics_erp.tab03.head_title'),
                  number:'1',
                  leftImg:require('../../assets/images/serviceAbility/erp_tab03_img_l.jpg'),
                  rightImg:require('../../assets/images/serviceAbility/erp_tab03_img_r.png'),
                  title01:this.$t('service.dynamics_erp.tab03.title01'),
                  description01:this.$t('service.dynamics_erp.tab03.description01'),
                  description02:this.$t('service.dynamics_erp.tab03.description02'),
                  description03:this.$t('service.dynamics_erp.tab03.description03'),
                  description04:this.$t('service.dynamics_erp.tab03.description04'),
                  description05:this.$t('service.dynamics_erp.tab03.description05'),
                  description06:this.$t('service.dynamics_erp.tab03.description06'),
                  description07:this.$t('service.dynamics_erp.tab03.description07')
                }
              ]
            }
        },
        methods:{
          changeCoolLightIndex(){
            this.coolLightIndex = 0
            console.log('this.coolLightIndex',this.coolLightIndex)
          },
         

            //点击切换tab
            changeSwiper(index){
              this.erpCurrent = index;
            },

        }
    }
</script>

